import React from 'react';
import EmotionModalSpinner from './modalSpinner-emotion';
import CompiledModalSpinner from './modalSpinner-compiled';
import { fg } from '@atlaskit/platform-feature-flags';
var ModalSpinner = function ModalSpinner(props) {
  return fg('platform_media_compiled') ? /*#__PURE__*/React.createElement(CompiledModalSpinner, props) : /*#__PURE__*/React.createElement(EmotionModalSpinner, props);
};
export { Blanket, SpinnerWrapper } from './modalSpinner-emotion';
export default ModalSpinner;